/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Form_LabelInputs */

const en_options_general_form_label = /** @type {(inputs: Options_General_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General Settings`)
};

const fr_options_general_form_label = /** @type {(inputs: Options_General_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres généraux`)
};

const de_options_general_form_label = /** @type {(inputs: Options_General_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemeine Einstellungen`)
};

const it_options_general_form_label = /** @type {(inputs: Options_General_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni generali`)
};

const ru_options_general_form_label = /** @type {(inputs: Options_General_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общие настройки`)
};

const es_options_general_form_label = /** @type {(inputs: Options_General_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración general`)
};

const zh_cn2_options_general_form_label = /** @type {(inputs: Options_General_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常规设置`)
};

const ja_options_general_form_label = /** @type {(inputs: Options_General_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般設定`)
};

const hi_options_general_form_label = /** @type {(inputs: Options_General_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामान्य सेटिंग्स`)
};

const pt_pt2_options_general_form_label = /** @type {(inputs: Options_General_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações gerais`)
};

/**
* | output |
* | --- |
* | "General Settings" |
*
* @param {Options_General_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_form_label = /** @type {((inputs?: Options_General_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_form_label(inputs)
	if (locale === "de") return de_options_general_form_label(inputs)
	if (locale === "it") return it_options_general_form_label(inputs)
	if (locale === "ru") return ru_options_general_form_label(inputs)
	if (locale === "es") return es_options_general_form_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_form_label(inputs)
	if (locale === "ja") return ja_options_general_form_label(inputs)
	if (locale === "hi") return hi_options_general_form_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_form_label(inputs)
	return en_options_general_form_label(inputs)
});